export enum errorAuth {
	'EMAIL_NONE' = 'Please input your email!',
	'EMAIL_FORMAT' = 'Email not correct format!',
	'PASSWORD_NONE' = 'Please input your password!',
	'PASSWORD_LENGTH' = 'Password over 6 chacracters',

	'NAME_NONE' = 'Please input your name!',
	'PHONE_NONE' = 'Please input your phone!',
	'PHONE_NUMBER' = 'Phone not correct format!',
	'PASSWORD_INCORRECT' = 'Confirm password is incorrect',
	'PASSWORD_CONFIRM_NONE' = 'Please input confirm your password!',
	'PASSWORD_SAME_CONNECTED_NONE' = 'Not same connected password',
	'PASSWORD_SAME_OLD_NONE' = 'Not same old password',
}
